import clsx from 'clsx';
import * as React from 'react';
import { FieldError } from 'react-hook-form';

type FieldWrapperProps = {
  label?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  helperText?: React.ReactNode;
  error?: FieldError;
  description?: string;
};

export type FieldWrapperPassThroughProps = Omit<FieldWrapperProps, 'className' | 'children'>;

export const FieldWrapper = (props: FieldWrapperProps) => {
  const { label, className, error, children, helperText } = props;
  return (
    <div>
      <label
        className={clsx(
          'block text-sm font-medium text-ebony-clay-700 capitalize-first',
          className
        )}
      >
        {label}
        <div className="mt-1">{children}</div>
      </label>
      {!error?.message && helperText && (
        <div className="mt-1 text-xs text-ebony-clay-500">{helperText}</div>
      )}
      {error?.message && (
        <div role="alert" aria-label={error.message} className="mt-1 text-xs text-red-500">
          {error.message}
        </div>
      )}
    </div>
  );
};
